import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'masterpass-link-card-form',
  templateUrl: './masterpass-link-card-form.component.html',
  styleUrls: ['./masterpass-link-card-form.component.scss'],
})
export class MasterpassLinkCardFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
